export default {
	title: 'ポートフォリオ',
	description: 'すべてのGerositusプロジェクト',
	actions: {
		back_to_this: 'ポートフォリオに戻る'
	},
	search_projects: 'プロジェクトを検索',
	cta: {
		welcome:
			'Gerositus Strategy Suiteへようこそ。ご利用ありがとうございます。',
		subscribe: '今すぐ登録',
		create_permission: 'すると、新しいプロジェクトを作成できます。'
	},
	tabs: {
		risks: {
			title: 'リスクと機会の設定'
		}
	}
};
